<template>
    <div>
        <action-icon icon="FileIcon" :tooltip="$t('file')" @click="showFile()"
            />
        <vs-popup :title="title" :active.sync="popupActive" id="po-file-viewer" >
            <div v-if="popupActive">
                <iframe :src="`${baseUrl}${request_id}`" class="w-full show-pdf" :style="{ height: '70vh' }"></iframe>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import { BASE_URL } from '@/urls.js'

export default {
    components: {
        ActionIcon,
    },
    data: () => ({
        baseUrl: BASE_URL + 'internal_api/po/file/',
        popupActive: false,
    }),
    methods: {
        showFile() {
            this.popupActive = true
        },
    },
    props: {
        request_id: {
            type: String,
            default: '0',
        },
        title: {
            type: String,
            default: 'start date',
        }
    }
}
</script>
<style>
.show-pdf {
    display: block;
    border: none;
}

#po-file-viewer>div.vs-popup {
    width: calc(100% - 30px) !important;
}
</style>